import styled from "styled-components"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const EventAdditionalInfos = styled.section`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  border-top: 1px solid ${(props) => props.theme.b_color_gradients.b_light};
`
const EventsItemDate = styled.div`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const EventsItemDateTo = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_light};
`
const EventsItemTaxo = styled.div`
  & > a {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const EventFooterBack = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const EventFooterDate = styled.div`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const EventPlaceIcon = styled(Icon)`
  color: ${(props) => props.theme.b_color_gradients.b_light};
`
const EventPlaceTitle = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_light};
`

const EventsItemTitle = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export {
  EventAdditionalInfos,
  EventsItemDate,
  EventsItemDateTo,
  EventsItemTaxo,
  EventFooterBack,
  EventFooterDate,
  EventPlaceIcon,
  EventPlaceTitle,
  EventsItemTitle,
}
